import formatSubresources from '@tabeo/sharpei/utils/formatSubresources'

const subResources = formatSubresources([
  'offers',
  'consumers',
  'merchants',
  'leads',
  'bills',
  'tickets',
  'owners',
  'creator',
  'resolver',
  'uploads',
  'reverseRelatedTickets',
])

export default subResources
